import React, { createContext, useState } from 'react';

export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [closeSideNav, setCloseNavBar] = useState(false);

  return (
    <SidebarContext.Provider value={{ closeSideNav, setCloseNavBar }}>
      {children}
    </SidebarContext.Provider>
  );
};